import { SVGProps } from 'react';

const LicencePlate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 5H2v14h20zm-2.069 3.938H4.07v6.124h15.862z"
      clipRule="evenodd"
    />
  </svg>
);
export default LicencePlate;
